import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  input: {
    '& input': {
      padding: '3.5px 4px 3.5px 12px!important',
    },
  },
}));
